(function () {
    'use strict';

    angular.module("imApp").factory("doDataImpImportModalService", ['$ihttp', function ($ihttp) {
        let service = {};

        return service;
    }]);
})();
